/**
 *
 * @param {string} name
 * @returns
 */

const url = `app`;

export const LOAD_PARTIES = `${url}/LOAD_PARTIES`;
export const LOAD_PARTIES_SUCCESS = `${url}/LOAD_PARTIES_SUCCESS`;
export const LOAD_PARTIES_ERROR = `${url}/LOAD_PARTIES_ERROR`;


//category
export const LOAD_PARTIES_CATEGORY = `${url}/LOAD_PARTIES_CATEGORY`;
export const LOAD_PARTIES_CATEGORY_SUCCESS = `${url}/LOAD_PARTIES_CATEGORY_SUCCESS`;
export const LOAD_PARTIES_CATEGORY_ERROR = `${url}/LOAD_PARTIES_CATEGORY_ERROR`;

export const CREATE_PARTIES_CATEGORY = `${url}/CREATE_PARTIES_CATEGORY`;
export const CREATE_PARTIES_CATEGORY_SUCCESS = `${url}/CREATE_PARTIES_CATEGORY_SUCCESS`;
export const CREATE_PARTIES_CATEGORY_ERROR = `${url}/CREATE_PARTIES_CATEGORY_ERROR`;

export const CREATE_PARTIES = `${url}/CREATE_PARTIES`;
export const CREATE_PARTIES_SUCCESS = `${url}/CREATE_PARTIES_SUCCESS`;
export const CREATE_PARTIES_ERROR = `${url}/CREATE_PARTIES_ERROR`;

export const UPDATE_PARTIES = `${url}/UPDATE_PARTIES`;
export const UPDATE_PARTIES_SUCCESS = `${url}/UPDATE_PARTIES_SUCCESS`;
export const UPDATE_PARTIES_ERROR = `${url}/UPDATE_PARTIES_ERROR`;

export const DELETE_PARTIES = `${url}/DELETE_PARTIES`;
export const DELETE_PARTIES_SUCCESS = `${url}/DELETE_PARTIES_SUCCESS`;
export const DELETE_PARTIES_ERROR = `${url}/DELETE_PARTIES_ERROR`;

export const LOAD_PARTIES_RECORDS_META_DATA = `${url}/LOAD_PARTIES_RECORDS_META_DATA`;
export const LOAD_PARTIES_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_PARTIES_RECORDS_META_DATA_SUCCESS`;
export const LOAD_PARTIES_RECORDS_META_DATA_ERROR = `${url}/LOAD_PARTIES_RECORDS_META_DATA_ERROR`;
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`;

export const LOAD_PARTIES_COLLECT = `${url}/LOAD_PARTIES_COLLECT`;
export const LOAD_PARTIES_COLLECT_SUCCESS = `${url}/LOAD_PARTIES_COLLECT_SUCCESS`;
export const LOAD_PARTIES_COLLECT_ERROR = `${url}/LOAD_PARTIES_COLLECT_ERROR`;
export const LOAD_PARTIES_LEDGER_STATEMENT = `${url}/LOAD_PARTIES_LEDGER_STATEMENT`;
export const LOAD_PARTIES_LEDGER_STATEMENT_SUCCESS = `${url}/LOAD_PARTIES_LEDGER_STATEMENT_SUCCESS`;
export const LOAD_PARTIES_LEDGER_STATEMENT_ERROR = `${url}/LOAD_PARTIES_LEDGER_STATEMENT_ERROR`;

export const LOAD_PARTIES_PAY = `${url}/LOAD_PARTIES_PAY`;
export const LOAD_PARTIES_PAY_SUCCESS = `${url}/LOAD_PARTIES_PAY_SUCCESS`;
export const LOAD_PARTIES_PAY_ERROR = `${url}/LOAD_PARTIES_PAY_ERROR`;

export const LOAD_PARTIES_TRANSACTION = `${url}/LOAD_PARTIES_TRANSACTION`;
export const LOAD_PARTIES_TRANSACTION_SUCCESS = `${url}/LOAD_PARTIES_TRANSACTION_SUCCESS`;
export const LOAD_PARTIES_TRANSACTION_ERROR = `${url}/LOAD_PARTIES_TRANSACTION_ERROR`;

export const LOAD_STATE_LIST = `${url}/LOAD_STATE_LIST`;
export const LOAD_STATE_LIST_SUCCESS = `${url}/LOAD_STATE_LIST_SUCCESS`;
export const LOAD_STATE_LIST_ERROR = `${url}/LOAD_STATE_LIST_ERROR`;


const constants = {
  LOAD_PARTIES,
  LOAD_PARTIES_SUCCESS,
  LOAD_PARTIES_ERROR,

  LOAD_PARTIES_COLLECT,
  LOAD_PARTIES_COLLECT_SUCCESS,
  LOAD_PARTIES_COLLECT_ERROR,

  LOAD_PARTIES_PAY,
  LOAD_PARTIES_PAY_SUCCESS,
  LOAD_PARTIES_PAY_ERROR,

  LOAD_STATE_LIST,
  LOAD_STATE_LIST_SUCCESS,
  LOAD_STATE_LIST_ERROR,

  LOAD_PARTIES_LEDGER_STATEMENT,
  LOAD_PARTIES_LEDGER_STATEMENT_SUCCESS,
  LOAD_PARTIES_LEDGER_STATEMENT_ERROR,

  LOAD_PARTIES_TRANSACTION,
  LOAD_PARTIES_TRANSACTION_SUCCESS,
  LOAD_PARTIES_TRANSACTION_ERROR,

  LOAD_PARTIES_CATEGORY,
  LOAD_PARTIES_CATEGORY_SUCCESS,
  LOAD_PARTIES_CATEGORY_ERROR,

  CREATE_PARTIES_CATEGORY,
  CREATE_PARTIES_CATEGORY_SUCCESS,
  CREATE_PARTIES_CATEGORY_ERROR,

  CREATE_PARTIES,
  CREATE_PARTIES_SUCCESS,
  CREATE_PARTIES_ERROR,

  UPDATE_PARTIES,
  UPDATE_PARTIES_SUCCESS,
  UPDATE_PARTIES_ERROR,
  DELETE_PARTIES,
  DELETE_PARTIES_SUCCESS,
  DELETE_PARTIES_ERROR,

  LOAD_RECORDS_VALID_CACHE,

  LOAD_PARTIES_RECORDS_META_DATA,
  LOAD_PARTIES_RECORDS_META_DATA_SUCCESS,
  LOAD_PARTIES_RECORDS_META_DATA_ERROR,
};

export default constants;
